import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { navigateToChart } from '../utils/helpers';

const useChartConfigClick = ({
  chartView,
  route,
  farmId,
  sectorId,
  onFullScreen,
}: {
  chartView: string;
  route: string;
  farmId: string;
  sectorId: string;
  onFullScreen: () => void;
}) => {
  const history = useHistory();
  return useCallback(() => {
    if (chartView === 'fullScreen') {
      onFullScreen();
      return;
    }
    navigateToChart(route, history, { farmId, sectorId });
  }, [chartView, route, farmId, sectorId, onFullScreen, history]);
};

export default useChartConfigClick;
